import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/report-management/sales-report`;

export const salesReportRoutesObj = {
  list: baseRoute,
} as const;

export type ISalesReportRouteParams = IExtractRouteParamMap<
  typeof salesReportRoutesObj
>;

export const salesReportPath = createPaths<
  typeof salesReportRoutesObj,
  ISalesReportRouteParams
>(salesReportRoutesObj);
